const map: Record<string, string> = {
  birthday: 'tada',
  postEvent: 'calendar',
  workiversary: 'trophy',
  firstDay: 'hatching_chick',
  companyHoliday: 'calendar',
  holiday: 'umbrella_on_the_ground',
  sick: 'face_with_medical_mask',
  other: 'house_building',
}

export default map
